var service = {};

if (process.env.NODE_ENV === 'production') {
    service.API_URL = 'https://api.manager.eduwity.com';
} else {
    service.API_URL = 'http://192.168.1.18:5000';
}

export default service;
